import './App.css';
import {CssBaseline} from "@mui/material";
import {Route, Routes} from "react-router-dom";
import {Error} from "./pages/Error";
import ClosedRegistrations from "./pages/ClosedRegistrations";
import {Logistics} from "./pages/Logistics";
import {Register} from "./pages/Register";
import {Home} from "./pages/Home";

function App() {
  // Chiusura definitiva dal 15 settembre 2026 alle 19:00 ora italiana (Roma = UTC+1, quindi 17:00 UTC)
  const cutoff = new Date(Date.UTC(2026, 8, 15, 17, 0, 0, 0)); // mese 1 = febbraio
  const registrationsClosed = new Date() >= cutoff;

  return (
    <div>
      <CssBaseline/>
      <Routes>
        <Route path={'/'} element={<Home/>}/>
        <Route path={'/error'} element={<Error/>}/>
        <Route path={'/register/:id'} element={registrationsClosed ? <ClosedRegistrations/> : <Register/>}/>
        <Route path={'/logistics/:id'} element={<Logistics/>}/>
      </Routes>
    </div>
  );
}

export default App;
